var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C10.0899 0 13 2.36079 13 5.27297C13 8.18514 10.0899 10.5459 6.5 10.5459C6.15525 10.5459 5.81687 10.524 5.48661 10.482C4.0904 11.876 2.42387 12.126 0.8125 12.1627V11.8215C1.68259 11.3959 2.4375 10.6207 2.4375 9.73471C2.4375 9.61108 2.42788 9.4897 2.41003 9.37098C0.939961 8.4043 0 6.92774 0 5.27297C0 2.36079 2.91015 0 6.5 0Z",
    fill: "#C7C7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment-icon.013bdcc9bea8dbd657502c1d45eb5ef3.svg";
export { ForwardRef as ReactComponent };